// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application";

import AdminMainController from "./admin_main_controller";
application.register("admin-main", AdminMainController);

import ArticleController from "./article_controller";
application.register("article", ArticleController);

import ArticleHeadingsController from "./article_headings_controller";
application.register("article-headings", ArticleHeadingsController);

import CallButtonController from "./call_button_controller";
application.register("call-button", CallButtonController);

import CarouselController from "./carousel_controller";
application.register("carousel", CarouselController);

import CloudflareModalController from "./cloudflare_modal_controller";
application.register("cloudflare-modal", CloudflareModalController);

import CocoonedController from "./cocooned_controller";
application.register("cocooned", CocoonedController);

import CopyController from "./copy_controller";
application.register("copy", CopyController);

import FlashMessageController from "./flash_message_controller";
application.register("flash-message", FlashMessageController);

import GalleryController from "./gallery_controller";
application.register("gallery", GalleryController);

import HamburgerMenuController from "./hamburger_menu_controller";
application.register("hamburger-menu", HamburgerMenuController);

import HeaderCallPopupController from "./header_call_popup_controller";
application.register("header-call-popup", HeaderCallPopupController);

import HelloController from "./hello_controller";
application.register("hello", HelloController);

import ImageViewerController from "./image_viewer_controller";
application.register("image-viewer", ImageViewerController);

import MenuController from "./menu_controller";
application.register("menu", MenuController);

import MenuItemController from "./menu_item_controller";
application.register("menu-item", MenuItemController);

import MenuModalController from "./menu_modal_controller";
application.register("menu-modal", MenuModalController);

import ModalOpenerController from "./modal_opener_controller";
application.register("modal-opener", ModalOpenerController);

import PageController from "./page_controller";
application.register("page", PageController);

import PhoneController from "./phone_controller";
application.register("phone", PhoneController);

import ProgressbarController from "./progressbar_controller";
application.register("progressbar", ProgressbarController);

import RatingController from "./rating_controller";
application.register("rating", RatingController);

import RunningLineController from "./running_line_controller";
application.register("running-line", RunningLineController);

import ScrollDisablerController from "./scroll_disabler_controller";
application.register("scroll-disabler", ScrollDisablerController);

import ScrollToTopController from "./scroll_to_top_controller";
application.register("scroll-to-top", ScrollToTopController);

import TableEditorController from "./table_editor_controller";
application.register("table-editor", TableEditorController);

import TabsController from "./tabs_controller";
application.register("tabs", TabsController);

import TrixTableController from "./trix_table_controller";
application.register("trix-table", TrixTableController);

import UploadFileNameViewerController from "./upload_file_name_viewer_controller";
application.register("upload-file-name-viewer", UploadFileNameViewerController);
